<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item active">Comparar Nóminas</li>
</ol>

<h1 class="page-header"><i class="fas fa-balance-scale"></i> Comparar Nómina vs. Base de Datos</h1>

<panel [noButton]="true">
  <div class="row">
    <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-12">
      <div class="input-group">
        <input type="file" id="file" class="form-control" accept=".xlsx" (change)="fileChangeEvent($event)">
        <button type="button" class="btn btn-outline-primary" [disabled]="!fileName || loading" (click)="compareFile()">
          <i class="fas fa-search"></i> Comparar
        </button>
        @if (fileName) {
          <button type="button" class="btn btn-outline-secondary" (click)="clearFile()">
            <i class="fas fa-times"></i>
          </button>
        }
      </div>
      @if (fileName) {
        <small class="text-muted">Archivo: {{ fileName }}</small>
      }
    </div>
  </div>
</panel>

@if (loading) {
  <div class="text-center my-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Procesando...</span>
    </div>
    <p class="mt-2">Comparando registros...</p>
  </div>
}

@if (result) {
  <div>
    <panel [noButton]="true">
      <div class="d-flex align-items-center gap-3 flex-wrap mb-3">
        <div><strong>Póliza:</strong> {{ result.policy.code }} - {{ result.policy.name }}</div>
        <div><strong>Período:</strong> {{ result.period | date:'yyyy-MM': 'UTC' }}</div>
      </div>
      <div class="row mb-3">
        <div class="col-md-3 col-6 mb-2">
          <div class="card border-success h-100">
            <div class="card-body text-center py-3">
              <div class="fs-4 fw-bold text-success">{{ result.summary.totalExcel }}</div>
              <small class="text-muted">Registros Excel</small>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-6 mb-2">
          <div class="card border-primary h-100">
            <div class="card-body text-center py-3">
              <div class="fs-4 fw-bold text-primary">{{ result.summary.totalDB }}</div>
              <small class="text-muted">Registros BD</small>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-6 mb-2">
          <div class="card border-success h-100">
            <div class="card-body text-center py-3">
              <div class="fs-4 fw-bold text-success">{{ result.summary.new }}</div>
              <small class="text-muted">Nuevos</small>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-6 mb-2">
          <div class="card border-warning h-100">
            <div class="card-body text-center py-3">
              <div class="fs-4 fw-bold text-warning">{{ result.summary.modified }}</div>
              <small class="text-muted">Modificados</small>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-6 mb-2">
          <div class="card border-danger h-100">
            <div class="card-body text-center py-3">
              <div class="fs-4 fw-bold text-danger">{{ result.summary.missing }}</div>
              <small class="text-muted">Faltantes</small>
            </div>
          </div>
        </div>
      </div>
      @if (result.summary.equal > 0) {
        <div class="row mb-3">
          <div class="col">
            <span class="badge bg-success fs-6">{{ result.summary.equal }} registros coinciden sin diferencias</span>
          </div>
        </div>
      }
      @if (result.summary.errors > 0) {
        <div class="row mb-3">
          <div class="col">
            <span class="badge bg-danger fs-6">{{ result.summary.errors }} errores de procesamiento</span>
          </div>
        </div>
      }
    </panel>
    @if (result.differences.length > 0 || result.errors.length > 0) {
      <div>
        <panel [noButton]="true">
          <div class="row mb-3">
            <div class="col-md-4">
              <label class="form-label fw-bold">Filtrar por tipo</label>
              <select class="form-select" [(ngModel)]="filterType">
                <option value="all">Todos ({{ result.differences.length }})</option>
                <option value="new">Nuevos en Excel ({{ result.summary.new }})</option>
                <option value="modified">Modificados ({{ result.summary.modified }})</option>
                <option value="missing">Faltantes en Excel ({{ result.summary.missing }})</option>
              </select>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-sm">
              <thead class="table-light">
                <tr>
                  <th>RUT</th>
                  <th>Nombre</th>
                  <th>Edad</th>
                  <th>Inicio Vigencia</th>
                  <th>Fin Vigencia</th>
                  <th>Total $ Excel</th>
                  <th>Total $ BD</th>
                  <th>Último Movimiento</th>
                  <th>Tipo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (diff of filteredDifferences; track diff.rut) {
                  <tr>
                    <td class="fw-bold">{{ diff.rut | numberPipe }}</td>
                    <td>{{ diff.nombreCompleto || '-' }}</td>
                    <td class="text-center">{{ diff.edad ?? '-' }}</td>
                    <td>{{ (diff.inicioVigencia | date:'dd-MM-yyyy') || '-' }}</td>
                    <td>{{ (diff.finVigencia | date:'dd-MM-yyyy') || '-' }}</td>
                    <td class="text-end">{{ (diff.totalSura != null ? '$ ' + (diff.totalSura | number:'1.0-0') : '-') }}</td>
                    <td class="text-end">{{ (diff.totalIasd != null ? '$ ' + (diff.totalIasd | number:'1.0-0') : '-') }}</td>
                    <td>
                      @if (diff.requestId) {
                        <button class="btn btn-sm btn-outline-success" (click)="openRequestModal(diff.requestId)">
                          <i class="fas fa-receipt"></i> {{ diff.ultimoMovimiento }}
                        </button>
                      } @else {
                        {{ diff.ultimoMovimiento || '-' }}
                      }
                    </td>
                    <td>
                      <span class="badge" [ngClass]="typeBadgeClass(diff.type)">{{ typeLabel(diff.type) }}</span>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-outline-info" (click)="openDetailModal(diff)">
                        <i class="fas fa-list"></i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          @if (filteredDifferences.length === 0) {
            <div class="text-center text-muted py-3">
              No hay diferencias para mostrar con el filtro seleccionado.
            </div>
          }
        </panel>
      </div>
    }
    @if (result.errors.length > 0) {
      <div>
        <panel [noButton]="true">
          <div class="panel-heading">
            <h4 class="panel-title"><i class="fas fa-exclamation-triangle text-danger"></i> Errores de procesamiento</h4>
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-bordered">
              <thead class="table-danger">
                <tr>
                  <th>Fila</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                @for (err of result.errors; track err.row) {
                  <tr>
                    <td>{{ err.row }}</td>
                    <td>{{ err.message }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </panel>
      </div>
    }
  </div>
}

<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Detalle de Coberturas - RUT {{ selectedDiff!.rut | numberPipe }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if (selectedDiff) {
      <div class="mb-3">
        <div><strong>Nombre:</strong> {{ selectedDiff.nombreCompleto || '-' }}</div>
        <div><strong>Edad:</strong> {{ selectedDiff.edad ?? '-' }}</div>
        <div><strong>Inicio Vigencia:</strong> {{ (selectedDiff.inicioVigencia | date:'dd-MM-yyyy') || '-' }}</div>
        <div><strong>Fin Vigencia:</strong> {{ (selectedDiff.finVigencia | date:'dd-MM-yyyy') || '-' }}</div>
        <div><strong>Tipo:</strong> <span class="badge" [ngClass]="typeBadgeClass(selectedDiff.type)">{{ typeLabel(selectedDiff.type) }}</span></div>
        <div><strong>Último Movimiento:</strong> {{ selectedDiff.ultimoMovimiento || '-' }}</div>
      </div>
    }
    <hr>
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead class="table-secondary">
            <tr>
              <th>Campo</th>
              <th>Valor Excel</th>
              <th>Valor BD</th>
            </tr>
          </thead>
          <tbody>
            @for (field of detailFields; track field.field) {
              <tr>
                <td>{{ field.field }}</td>
                <td class="text-end">{{ field.excel ?? '-' }}</td>
                <td class="text-end">{{ field.db ?? '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">Cerrar</button>
    </div>
  </ng-template>

  <ng-template #requestModal let-modal>
    <app-review-request [requestId]="selectedRequestId" [showHeader]="true" [showFooter]="false"></app-review-request>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-danger" (click)="modal.dismiss()">Cerrar</button>
    </div>
  </ng-template>
